module.exports = __webpack_public_path__ + "static/media/Smoke.30c78771.svg";